import { useState, useEffect, useRef } from "react";
import coatings from "../../assets/coatings.png";
import economy from "../../assets/economy.png";
import repairRehab from "../../assets/repair-rehab.png";
import substrateEval from "../../assets/substrate-eval.png";
import totalPic from "../../assets/total.png";
import APLOGO from "../../assets/APlogo.png"

import logoPic from "../../assets/logo.png";

const AD_INTERVAL_MS = 30 * 60 * 1000;

const VIDEOS = ["https://anugaman.rrco.co.in/public/img/ap-recording.mp4"];

const slides = [

  
  {
    type: "video",
    src: VIDEOS[0],
    tag: "Waterproofing",
    title: "Protect Every Wall",
    subtitle: "Asian Paints waterproofing — built to last through any weather.",
    gradientFrom: "#1E3A8A",
    gradientTo: "#0D9488",
    
  },
  
  
];

export default function AdPopup() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(0);
  const [animKey, setAnimKey] = useState(0);
  const [paused,  setPaused]  = useState(false);
  const autoRef  = useRef(null);
  const videoRef = useRef(null);

  const getClientKeys = () => {
    const id = localStorage.getItem("id");
    const email = (localStorage.getItem("email") || "").toLowerCase().trim();
    const keys = [];
    if (id) keys.push(`client_ad_seen_id_${id}`);
    if (email) keys.push(`client_ad_seen_email_${email}`);
    if (!keys.length) keys.push("client_ad_seen_default");
    return keys;
  };

  const hasSeenAd = () => {
    const keys = getClientKeys();
    // 1. Check localStorage
    for (const key of keys) {
      if (localStorage.getItem(key) === "true") return true;
    }
    // 2. Check cookies (persists across logouts and localStorage.clear)
    const cookies = document.cookie.split(";").map(c => c.trim());
    for (const key of keys) {
      const match = cookies.find(c => c.startsWith(`${key}=`));
      if (match && match.split("=")[1] === "true") {
        keys.forEach(k => {
          try { localStorage.setItem(k, "true"); } catch (e) {}
        });
        return true;
      }
    }
    return false;
  };

  const markAdSeen = () => {
    const keys = getClientKeys();
    keys.forEach(key => {
      try { localStorage.setItem(key, "true"); } catch (e) {}
      try {
        document.cookie = `${key}=true; path=/; max-age=315360000; SameSite=Lax`;
      } catch (e) {}
    });
  };

  useEffect(() => {
    if (hasSeenAd()) {
      setVisible(false);
      return;
    }
    // First time login - show once and mark as seen
    setVisible(true);
    markAdSeen();
  }, []);

  useEffect(() => {
    clearInterval(autoRef.current);
    if (!visible || paused) return;
    autoRef.current = setInterval(() => {
      setAnimKey(k => k + 1);
      setCurrent(prev => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(autoRef.current);
  }, [visible, paused, current]);

  // Force video play on video slides
  useEffect(() => {
    if (slides[current].type !== "video") return;
    const timer = setTimeout(() => {
      if (!videoRef.current) return;
      videoRef.current.load();
      videoRef.current.play().catch(() => {});
    }, 100);
    return () => clearTimeout(timer);
  }, [current]);

  const goTo = (idx) => { setAnimKey(k => k + 1); setCurrent(idx); setPaused(true); };
  const prev  = () => { setAnimKey(k => k + 1); setCurrent(c => (c - 1 + slides.length) % slides.length); setPaused(true); };
  const next  = () => { setAnimKey(k => k + 1); setCurrent(c => (c + 1) % slides.length); setPaused(true); };
  const close = () => {
    markAdSeen();
    setVisible(false);
  };

  if (!visible) return null;

  const slide = slides[current];
  const bg = `linear-gradient(135deg, ${slide.gradientFrom}, ${slide.gradientTo})`;

  return (
    <div
      onClick={close}
      style={{
        position: "fixed", inset: 0, zIndex: 9999,
        background: "rgba(0,0,0,0.78)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "16px",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        animation: "apIn 0.25s ease",
      }}
    >
      <style>{`
        @keyframes apIn    { from{opacity:0} to{opacity:1} }
        @keyframes apUp    { from{opacity:0;transform:translateY(40px) scale(0.95)} to{opacity:1;transform:translateY(0) scale(1)} }
        @keyframes apFade  { from{opacity:0} to{opacity:1} }
        @keyframes apPulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:0.5;transform:scale(1.25)} }
        @keyframes apBar   { from{width:0%} to{width:100%} }
        @keyframes apFloat { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-7px)} }
        .ap-close:hover { background:rgba(255,255,255,0.22)!important; transform:rotate(90deg) scale(1.1)!important; }
        .ap-nav:hover   { background:rgba(0,0,0,0.65)!important; }
        .ap-skip:hover  { border-color:#CBD5E1!important; color:#334155!important; }
        .ap-cta:hover   { transform:translateY(-2px) scale(1.02)!important; filter:brightness(1.1); }
        .ap-thumb:hover { opacity:1!important; transform:scale(1.08)!important; }
        .ap-dot:hover   { transform:scale(1.5)!important; }
      `}</style>

      {/* ══ MODAL ══ */}
      <div
        onClick={e => e.stopPropagation()}
        style={{
          width: "100%", maxWidth: 940,
          height: 460,
          borderRadius: 28,
          overflow: "hidden",
          boxShadow: "0 40px 100px rgba(0,0,0,0.85), 0 0 0 1px rgba(255,255,255,0.07)",
          animation: "apUp 0.4s cubic-bezier(0.34,1.56,0.64,1)",
          display: "flex",
        }}
      >

        {/* ── LEFT accent panel ── */}
        <div
          key={`left-${current}`}
          style={{
            width: 248,
            flexShrink: 0,
            background: bg,
            padding: "26px 22px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            position: "relative",
            overflow: "hidden",
            animation: "apFade 0.4s ease",
            transition: "background 0.5s ease",
          }}
        >
          {/* Deco */}
          <div style={{ position:"absolute", width:200, height:200, borderRadius:"50%", border:"1px solid rgba(255,255,255,0.1)", top:-60, right:-60, pointerEvents:"none" }} />
          <div style={{ position:"absolute", width:110, height:110, borderRadius:"50%", background:"rgba(255,255,255,0.07)", bottom:70, left:-35, pointerEvents:"none", animation:"apFloat 3s ease-in-out infinite" }} />
          <div style={{ position:"absolute", width:60, height:60, borderRadius:"50%", background:"rgba(255,255,255,0.05)", top:"40%", right:10, pointerEvents:"none", animation:"apFloat 2.5s ease-in-out infinite 1s" }} />

          <div style={{
            position:"absolute", bottom:110, left:22,
            zIndex:2,
          }}>
            <img
              src="https://www.apassure.asianpaints.com/content/dam/apassure/logos/Updated%20Reverse%20Logo%20with%20Tagline%2001_AP%20Assure_Logo_APL_CA.svg"
              alt="Total Assure"
              style={{ height:36, width:"auto", display:"block", objectFit:"contain" }}
            />
          </div>

          <div>
            {/* Brand chip */}
            <div style={{
              display:"inline-flex", alignItems:"center", gap:20,
              background:"#fff",
              borderRadius:12, padding:"9px 14px", marginBottom:18,
            }}>
              
              <img src={APLOGO} alt="AP " />
            </div>

            {/* Emoji */}
            <div style={{ fontSize:42, marginBottom:10, lineHeight:1, animation:"apFloat 3s ease-in-out infinite" }}>
              {slide.emoji}
            </div>

            {/* Tag */}
            <div style={{ fontSize:10, fontWeight:800, color:"rgba(255,255,255,0.5)", textTransform:"uppercase", letterSpacing:"0.14em", marginBottom:7 }}> 
              {slide.tag}
            </div>

            {/* Title */}
            <div style={{ fontSize:20, fontWeight:900, color:"#fff", lineHeight:1.25, marginBottom:9, letterSpacing:"-0.01em" }}>
              {slide.title}
            </div>

            {/* Subtitle */}
            <div style={{ fontSize:12, color:"rgba(255,255,255,0.65)", lineHeight:1.65, fontWeight:500 }}>
              {slide.subtitle}
            </div>
          </div>

          {/* Bottom: dots + progress + counter */}
          <div>
            <div style={{ display:"flex", gap:5, marginBottom:10, flexWrap:"wrap" }}>
              {slides.map((_, i) => (
                <button key={i} className="ap-dot" onClick={() => goTo(i)} style={{
                  width: i === current ? 22 : 7, height: 7,
                  borderRadius: 4, border: "none",
                  background: i === current ? "rgba(255,255,255,0.95)" : "rgba(255,255,255,0.25)",
                  cursor: "pointer", padding: 0,
                  transition: "all 0.35s cubic-bezier(0.34,1.56,0.64,1)",
                }} />
              ))}
            </div>
            <div style={{ height:2, background:"rgba(255,255,255,0.15)", borderRadius:4, overflow:"hidden", marginBottom:8 }}>
              <div key={`bar-${animKey}`} style={{
                height:"100%", background:"rgba(255,255,255,0.85)", borderRadius:4,
                animation: paused ? "none" : "apBar 6s linear forwards",
              }} />
            </div>
            <div style={{ fontSize:10, color:"rgba(255,255,255,0.38)", fontWeight:600 }}>
              {current + 1} / {slides.length}
            </div>
          </div>
        </div>

        {/* ── RIGHT media panel ── */}
        <div style={{ flex:1, display:"flex", flexDirection:"column", background:"#0A0A0A", overflow:"hidden" }}>

          {/* Top bar */}
          <div style={{
            display:"flex", alignItems:"center", justifyContent:"flex-end",
            padding:"11px 16px",
            background:"rgba(255,255,255,0.025)",
            borderBottom:"1px solid rgba(255,255,255,0.05)",
            flexShrink:0,
          }}>
            {/* <div style={{ display:"flex", alignItems:"center", gap:7 }}>
              <div style={{ width:7, height:7, borderRadius:"50%", background:"#22C55E", animation:"apPulse 1.5s infinite", boxShadow:"0 0 8px #22C55E" }} />
              <span style={{ fontSize:10, fontWeight:700, color:"rgba(255,255,255,0.4)", letterSpacing:"0.1em" }}>LIVE SHOWCASE</span>
            </div> */}
            <button className="ap-close" onClick={close} style={{
              width:30, height:30, borderRadius:"50%",
              background:"rgba(255,255,255,0.07)",
              border:"1px solid rgba(255,255,255,0.12)",
              color:"rgba(255,255,255,0.7)", fontSize:18,
              cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center",
              transition:"all 0.2s ease",
            }}>×</button>
          </div>

          {/* ── MEDIA ── */}
          <div style={{ position:"relative", flex:1, overflow:"hidden", minHeight:0 }}>

            {slide.type === "image" ? (
              <img
                key={`img-${animKey}`}
                src={slide.src}
                alt={slide.title}
                style={{
                  width:"100%", height:"100%",
                  objectFit:"contain",       // contain so small images aren't blurry/cropped
                  objectPosition:"center",
                  display:"block",
                  background:"#111",
                  animation:"apFade 0.35s ease",
                }}
              />
            ) : (
              <video
                ref={videoRef}
                key={`vid-${animKey}`}
                autoPlay muted loop playsInline
                style={{
                  width:"100%", height:"100%",
                  objectFit:"cover", display:"block",
                  animation:"apFade 0.35s ease",
                }}
              >
                <source src={slide.src} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}

            {/* Gradient overlay */}
            <div style={{ position:"absolute", inset:0, background:"linear-gradient(to top, rgba(0,0,0,0.4) 0%, transparent 50%)", pointerEvents:"none" }} />

            {/* Prev */}
            <button className="ap-nav" onClick={prev} style={{
              position:"absolute", left:12, top:"50%", transform:"translateY(-50%)",
              width:38, height:38, borderRadius:"50%",
              background:"rgba(0,0,0,0.5)", border:"1px solid rgba(255,255,255,0.15)",
              color:"#fff", fontSize:20, cursor:"pointer",
              display:"flex", alignItems:"center", justifyContent:"center",
              transition:"all 0.2s ease", backdropFilter:"blur(4px)",
            }}>‹</button>

            {/* Next */}
            <button className="ap-nav" onClick={next} style={{
              position:"absolute", right:12, top:"50%", transform:"translateY(-50%)",
              width:38, height:38, borderRadius:"50%",
              background:"rgba(0,0,0,0.5)", border:"1px solid rgba(255,255,255,0.15)",
              color:"#fff", fontSize:20, cursor:"pointer",
              display:"flex", alignItems:"center", justifyContent:"center",
              transition:"all 0.2s ease", backdropFilter:"blur(4px)",
            }}>›</button>

            {/* Video type badge */}
            {slide.type === "video" && (
              <div style={{
                position:"absolute", top:12, left:12,
                background:"rgba(0,0,0,0.6)", backdropFilter:"blur(6px)",
                border:"1px solid rgba(255,255,255,0.15)",
                borderRadius:20, padding:"4px 10px",
                fontSize:10, fontWeight:700, color:"#fff",
                display:"flex", alignItems:"center", gap:5,
              }}>
                <div style={{ width:6, height:6, borderRadius:"50%", background:"#EF4444", animation:"apPulse 1s infinite" }} />
                VIDEO
              </div>
            )}
          </div>

          {/* ── BOTTOM: thumbnails + CTA ── */}
          <div style={{
            display:"flex", alignItems:"center", justifyContent:"space-between",
            padding:"10px 14px",
            background:"#fff",
            borderTop:"1px solid #F1F5F9",
            gap:12, flexShrink:0,
          }}>
            {/* Thumbnails */}
            <div style={{ display:"flex", gap:6, alignItems:"center" }}>
              {slides.map((s, i) => (
                <button key={i} className="ap-thumb" onClick={() => goTo(i)} style={{
                  width:44, height:32, borderRadius:7,
                  overflow:"hidden",
                  border:`2px solid ${i === current ? slides[i].gradientFrom : "rgba(0,0,0,0.1)"}`,
                  cursor:"pointer", padding:0,
                  transition:"all 0.2s ease",
                  opacity: i === current ? 1 : 0.5,
                  flexShrink:0,
                  background:"#000",
                }}>
                  {s.type === "image" ? (
                    <img src={s.src} alt="" style={{ width:"100%", height:"100%", objectFit:"cover", display:"block" }} />
                  ) : (
                    <div style={{
                      width:"100%", height:"100%",
                      background:`linear-gradient(135deg,${s.gradientFrom},${s.gradientTo})`,
                      display:"flex", alignItems:"center", justifyContent:"center",
                      fontSize:12, color:"#fff",
                    }}>▶</div>
                  )}
                </button>
              ))}
            </div>

            {/* CTA */}
            <div style={{ display:"flex", gap:8, flexShrink:0 }}>
              <button className="ap-skip" onClick={close} style={{
                padding:"8px 16px", borderRadius:10,
                border:"1.5px solid #E2E8F0", background:"transparent",
                color:"#94A3B8", fontSize:12, fontWeight:600,
                cursor:"pointer", transition:"all 0.2s ease",
              }}>Skip</button>
              
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}